import React from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { useJwt } from "react-jwt";
import {
  CreateEmployee,
  GetAllRole,
  GetEmployeeStatus,
} from "../apiconfig/authService";
import { RiLoaderFill } from "react-icons/ri";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash, FaStar } from "react-icons/fa";

function AddEmployee() {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [emailid, setEmailID] = useState("");
  const [empcode, setEmpcode] = useState("");
  const [employeephone, setEmployeePhone] = useState("");
  const [designation, setDesignation] = useState("");
  const [statusid, setStatusid] = useState(1);
  const [roleid, setRoleid] = useState("");
  const [statusData, setStatusData] = useState([]);
  const [rolesData, setRolesData] = useState([]);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isMobileNumberValid, setIsMobileNumberValid] = useState(true);
  const [isMobileNumberMessage, setIsMobileNumberMessage] = useState("");
  const [isTouched, setIsTouched] = useState(false);

  const handleFirstNameChange = (e) => {
    setFirstname(e.target.value);
  };

  const handleLastnameChange = (e) => {
    setLastname(e.target.value);
  };

  const handleEmployeeCodeChange = (e) => {
    setEmpcode(e.target.value);
  };

  const handleEmployeePhoneChange = (e) => {
    setEmployeePhone(e.target.value);
    setIsTouched(true); // mark as touched once user types
  };

  const handleDesignationChange = (e) => {
    setDesignation(e.target.value);
  };

  const handleEmailIdChange = (e) => {
    setEmailID(e.target.value);
  };

  const handleStatusIdChange = (e) => {
    setStatusid(Number(e.target.value));
  };

  const handleRoleIdChange = (e) => {
    setRoleid(e.target.value);
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (!firstname.trim()) {
        toast.error("First Name is required");
        return;
      }
      if (!lastname.trim()) {
        toast.error("Last Name is required");
        return;
      }
      if (!emailid.trim()) {
        toast.error("Email Id is required");
        return;
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(emailid)) {
        toast.error("Invalid Email Id format");
        return;
      }
      if (!password.trim()) {
        toast.error("Password is required");
        return;
      }
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
      if (!passwordRegex.test(password)) {
        toast.error(
          "Invalid password. It must contain at least one lowercase letter, one uppercase letter, one digit, one special character, and be at least 8 characters long."
        );
        return;
      }
      if (password !== confirmPassword) {
        toast.error("Password not matches");
        return;
      }
      if (!employeephone.trim()) {
        toast.error("Contact Number is required");
        return;
      }
      const employeephoneRegex = /^\d{10}$/; // exactly 10 digits
      if (!employeephoneRegex.test(employeephone)) {
        toast.error("Invalid phone number.");
        return;
      }
       if (!empcode.trim()) {
         toast.error("Employee Code is required");
         return;
       }
      if (!roleid.trim()) {
        toast.error("Please select role");
        return;
      }
      if (!designation.trim()) {
        toast.error("Designation is required");
        return;
      }
    } catch (error) {
       toast.error(error.message);
       window.scrollTo(0, 0);
       return;
    }

    let response;
    try {
      setLoading(true);
      response = await CreateEmployee(
        {
          firstname,
          password,
          lastname,
          empcode,
          employeephone,
          designation,
          emailid,
          statusid,
          roleid,
        },
        localStorage.getItem("accessToken")
      );
      if (response.status === 201) {
        setLoading(false);
        navigate("/employee");
        toast.success("Employee Added Successfully");
        window.scrollTo(0, 0);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        toast.error("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isTouched) return; // don’t validate until touched

    if (employeephone.length === 0) {
      setIsMobileNumberValid(true); // empty is fine until user finishes
      setIsMobileNumberMessage("");
    } else if (employeephone.length < 10 || employeephone.length > 11) {
      setIsMobileNumberValid(false);
      setIsMobileNumberMessage(
        "Mobile number not valid (must be 10–11 digits)."
      );
    } else {
      setIsMobileNumberValid(true);
      setIsMobileNumberMessage("");
    }
  }, [employeephone, isTouched]);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetEmployeeStatus(
          localStorage.getItem("accessToken")
        );
        const rolesResponse = await GetAllRole(
          localStorage.getItem("accessToken")
        );
        setStatusData(statusResponse.data.statuses);
        setRolesData(rolesResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Employee</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/employee" className="btn btn-primary px-4">
              View All
            </NavLink>
          </div>
        </div>

        <div
          role="tabpanel"
          className="personal-info tab-pane active storetab"
          id="pi"
        >
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="catName">Firstname</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={firstname}
                onChange={handleFirstNameChange}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Firstname"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="catName">Lastname</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={lastname}
                onChange={handleLastnameChange}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Lastname"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="catName">Email ID</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={emailid}
                onChange={handleEmailIdChange}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Email ID"
                autoComplete="off"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="floatingPassword">Password</label>
                <FaStar size={7} className="text-danger" />
              </div>

              <div className="input-group my-2">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-control custom-input"
                  id="floatingPassword"
                  placeholder="Password"
                  autoComplete="off"
                />
                <span
                  className="input-group-text bg-transparent border-0"
                  id="password-toggle"
                  onClick={togglePasswordVisibility}
                  style={{ cursor: "pointer" }}
                >
                  {showPassword ? (
                    <FaEyeSlash size={15} />
                  ) : (
                    <FaEye size={15} />
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="floatingInput">Confirm Password</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <div className="input-group my-2">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="form-control custom-input"
                  id="floatingPassword"
                  placeholder="Confirm Password"
                  autoComplete="off"
                />
                <span
                  className="input-group-text bg-transparent border-0"
                  id="password-toggle"
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                  style={{ cursor: "pointer" }}
                >
                  {showConfirmPassword ? (
                    <FaEyeSlash size={15} />
                  ) : (
                    <FaEye size={15} />
                  )}
                </span>
              </div>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="catName">Employee Code</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={empcode}
                onChange={handleEmployeeCodeChange}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Employee Code"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex align-items-center">
                <div className="d-flex">
                  <label htmlFor="catName">Phone Number</label>
                   <FaStar size={7} className="text-danger" />
                </div>
                {!isMobileNumberValid && (
                  <span className="text-danger" style={{marginLeft: "40px", fontSize: "10px"}}>
                    {isMobileNumberMessage}
                  </span>
                )}
              </div>
              <input
                type="text"
                value={employeephone}
                onChange={handleEmployeePhoneChange}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Phone Number"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="catName">Designation</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={designation}
                onChange={handleDesignationChange}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Designation"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="floatingInput">Status</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <select
                className="form-select custom-input my-2"
                onChange={handleStatusIdChange}
                value={statusid}
              >
                {statusData?.map((item, index) => (
                  <option value={item.statusid} key={index}>
                    {item.status}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="floatingInput">Role</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <select
                className="form-select custom-input my-2 my-2"
                onChange={handleRoleIdChange}
                value={roleid}
              >
                <option value="">Choose a role</option>
                {rolesData?.map((item, index) => (
                  <option key={index} value={item.roleid}>
                    {item.rolename}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="row">
            <div className="col-12" style={{ height: "40px", width: "80px" }}>
              {loading ? (
                <div
                  className="btn btn-primary loader-active save-btn"
                  style={{ height: "100%", width: "100%" }}
                >
                  <RiLoaderFill
                    size={20}
                    className="spin-animation"
                    color="white"
                  />
                </div>
              ) : (
                <button
                  type="submit"
                  disabled={loading}
                  onClick={handleSubmitClick}
                  className="btn btn-primary save-btn text-uppercase"
                  style={{ height: "100%", width: "100%" }}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default AddEmployee;
